import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import ServicesMenuOptionsSelector from 'selectors/ServicesMenuOptionsSelector';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { selectService } from 'actions/filterActions';
import { updateProfile } from 'actions/userActions';
import { PLAN_CATEGORY } from 'config/constants';
import { fetchServices } from 'actions/serviceActions';
import './LanguageFilter.css';

import TopicFilter from './TopicFilter';

class LanguageFilter extends Component {
  componentDidMount() {
    this.handleSelectDefaultService();
    if (_.isEmpty(this.props.services)) this.props.fetchServices();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.menuOptions !== this.props.menuOptions && !this.props.selectedService.id) {
      this.handleSelectDefaultService();
    }

    if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
      if (this.props.isAuthenticated) {
        // update profile
        const {
          updateProfile: updateProfileFn,
          selectedService: { category, language }
        } = this.props;

        if (language && category) {
          updateProfileFn({ category, language }, false);
        }
      } else {
        this.handleSelectDefaultService();
      }
    }
  }

  handleSelectDefaultService = () => {
    const {
      user,
      location,
      menuOptions: { Language },
      selectedService
    } = this.props;

    let service = null;
    let category = null;

    if (Language && Language.length) {
      let language = _.isEmpty(user) ? location.query.language || 'Spanish' :
        location.query.language || user.language || selectedService.language || 'Spanish';
      language = language.toLowerCase();
      service = Language.find(item => item.description.toLowerCase().indexOf(language) !== -1);
      category = PLAN_CATEGORY.LANGUAGE;
    }

    service && this.handleServiceSelect(category, service);
  }

  handleServiceSelect = (category, service) => {
    const { selectService: selectServiceFn, updateProfile: updateProfileFn, user } = this.props;

    const language = service.description;
    selectServiceFn({ id: service.id, category, language });

    if (!_.isEmpty(user)) {
      updateProfileFn({ category, language }, false);
    }
  }

  handleClickMenuItem = (category, service) => {
    this.handleServiceSelect(category, service);
    browserHistory.push('/schedule-lesson');
  }

  renderError(error) {
    return <div className="text-center text-danger">{error.message}</div>;
  }

  renderMenuItem(category, service, title) {
    return (
      <a
        href="#"
        key={`service_${service.id}`}
        className={classNames(
          'dropdown-item',
          'menu-item',
          {
            selected: service.id === this.props.selectedService.id
          },
          { [category]: category }
        )}
        onClick={this.handleClickMenuItem(service)}
      >
        {title}
      </a>
    );
  }

  renderMenuOptions() {
    const { menuOptions } = this.props;

    // handle error loading services
    if (menuOptions.error) {
      return this.renderError(menuOptions.error);
    }

    // if no services are loaded yet
    if (menuOptions.status === 'loading') {
      return <div className="text-center"> Loading.... </div>;
    }

    return (
      <Fragment>
        <label className="language-list-label">LANGUAGES</label>
        {menuOptions.Language.length > 0 && (
          <TopicFilter
            category={PLAN_CATEGORY.LANGUAGE}
            elementID="language-topic-filter"
            services={menuOptions.Language}
            selectedServiceId={this.props.selectedService.id}
            title="Language"
            onClickMenuItem={this.handleClickMenuItem}
          />
        )}
      </Fragment>
    );
  }

  renderMobileMenuItems(category, service, title) {
    return (
      <a
        href="#"
        key={`service_${service.id}`}
        className={classNames('mobile-menu-item', 'menu-item', {
          selected: service.id === this.props.selectedService.id
        })}
        onClick={() => {
          this.handleClickMenuItem(category, service);
        }}
      >
        {title}
      </a>
    );
  }

  renderMobileMenuOptions() {
    const { menuOptions } = this.props;

    // handle error loading services
    if (menuOptions.error) {
      return this.renderError(menuOptions.error);
    }

    // if no services are loaded yet
    if (menuOptions.status === 'loading') {
      return <div className="text-center"> Loading.... </div>;
    }

    return (
      <div>
        {menuOptions.Language.length > 0 && (
          <div>
            <p className="m-0 bg-faded mobile-menu-item group">Language</p>
            {menuOptions.Language.map(service => this.renderMobileMenuItems(PLAN_CATEGORY.LANGUAGE,
              service, service.description))}
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        <div className="LanguageFilter filter-sidebar-component hidden-sm-down">
          {this.renderMenuOptions()}
        </div>
        <div className="LanguageFilter mobile card languages-filter hidden-md-up">
          <div
            id="languages-heading"
            className="card-header bg-inverse"
            role="tab"
            data-toggle="collapse"
            data-target="#language-list"
            data-parent="#accordion"
            aria-expanded="true"
            aria-controls="language-list"
          >
            <label className="mb-0"> Services </label>
          </div>

          <div
            id="language-list"
            className="collapse show"
            role="tabpanel"
            aria-labelledby="languages-heading"
          >
            <div className="list-group">{this.renderMobileMenuOptions()}</div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !_.isEmpty(state.user.profile),
    user: state.user.profile,
    selectedService: state.filters.selectedService,
    menuOptions: ServicesMenuOptionsSelector(state)
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      selectService,
      updateProfile,
      fetchServices
    }
  )(LanguageFilter)
);



// WEBPACK FOOTER //
// ./src/components/filters/LanguageFilter/LanguageFilter.js